const originalFetch = window.fetch;

let sessionExpiredDispatched = false;

window.fetch = async (url, options = {}) => {
  const token = sessionStorage.getItem("jwtToken");

  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };

  const response = await originalFetch(url, {
    ...options,
    headers
  });

  if ((response.status === 401 || response.status === 403) && token) {
    if (!sessionExpiredDispatched) {
      sessionExpiredDispatched = true;
      sessionStorage.clear();
      window.dispatchEvent(new Event("SESSION_EXPIRED"));
    }
  }

  return response;
};
